// Shared lock for concurrent refresh token requests across both
// the deprecated ApiClientInstance and the useAPIClientHelper hook.
// Only the first 401 triggers a refresh — all others await the same Promise.

let refreshTokenPromise: Promise<void> | null = null;

export const getRefreshTokenPromise = () => refreshTokenPromise;
export const setRefreshTokenPromise = (p: Promise<void> | null) => {
  refreshTokenPromise = p;
};
